import { render } from "./SelecionarCidade.vue?vue&type=template&id=11395b62&ts=true"
import script from "./SelecionarCidade.vue?vue&type=script&lang=ts"
export * from "./SelecionarCidade.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__